import { render } from "./EditModule.vue?vue&type=template&id=2ce92221"
import script from "./EditModule.vue?vue&type=script&lang=js"
export * from "./EditModule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__